import React from "react";
import { Input, Text, VStack } from "@chakra-ui/react";

interface Props {
  textboxName: string;
}

const AudioTextbox: React.FC<Props> = ({textboxName}: Props) => {
  return (
    <VStack align="start" spacing="3px" mt="10px">
      <Text fontWeight="300" fontSize="13.38px">
        {textboxName}
      </Text>
      <Input size="xs" variant="outline" borderRadius="6px"/>
    </VStack>
  );
};

export default AudioTextbox;